<h1 mat-dialog-title>{{ this.header }}</h1>
<div mat-dialog-content>
	{{ this.text }}
</div>
